import React, { useEffect, useState } from 'react';
import { PiWarningFill } from "react-icons/pi";

const OfflineOverlay = ({ children }) => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOnline = () => setIsOffline(false);
    const goOffline = () => setIsOffline(true);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  useEffect(() => {
    if (isOffline) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOffline]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (isOffline) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    if (isOffline) {
      window.addEventListener("keydown", handleKeyDown, true);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [isOffline]);

  return (
    <div className="relative">
      {isOffline && (
        <>
          <div className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm pointer-events-none select-none" />
          <div className="fixed top-0 left-0 z-50 w-full bg-[#FFF6F0] border-b justify-center h-[64px] border-yellow-400 text-[#B95000] flex items-center gap-2 text-sm font-medium shadow-sm px-4">
            <PiWarningFill className="w-5 h-5 text-[#B95000]" />
            <div className="text-[16px]">
              <strong className="font-semibold">Warning:</strong>
              <span className="font-medium"> You are currently offline, but your previous actions have been saved.</span>
            </div>
          </div>
        </>
      )}

      <div className={`relative z-10 ${isOffline ? 'pt-[64px]' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default OfflineOverlay;
